import { NgModule } from '@angular/core';
import {
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatListModule,
    MatBadgeModule,
    MatSnackBarModule,
    MatTreeModule,
    MatPaginatorModule,
    MatGridListModule,
    MatChipsModule
    
} from '@angular/material';
/**
 * NgModule that includes all Material modules that are required to serve the app
 */
@NgModule({
    exports: [
        MatExpansionModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatDialogModule,
        MatToolbarModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        MatSliderModule,
        MatFormFieldModule,
        MatInputModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatMenuModule,
        MatCardModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSelectModule,
        MatTableModule,
        MatRadioModule,
        MatDividerModule,
        MatButtonToggleModule,
        MatPaginatorModule,
        MatTooltipModule,
        MatListModule,
        MatBadgeModule,
        MatSnackBarModule,
        MatTreeModule,
        MatGridListModule,
        MatInputModule,
        MatChipsModule
    ],
})
export class CustomMaterialModule {}
